import React from 'react';
import { TargetIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images } from '../data/content';
export function Hero() {
  return <header className="relative bg-cream px-4 pb-14 pt-6 sm:pt-10" data-id="element-162" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-5xl" data-id="element-163" data-mp="4lqkazhutj53">
        <div className="flex items-center justify-center gap-2" data-id="element-164" data-mp="4mrxpamcehpz">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-ink font-serif text-lg font-black text-gold" data-id="element-165" data-mp="1297aw07qkt7q">R</span>
          <span className="font-serif text-lg font-black tracking-tight text-ink" data-id="element-166" data-mp="xbpd95z660f1">
            RHINO <span className="text-gold-dark" data-id="element-167" data-mp="sa9r1al99nv2">OPERATING</span> PLAYBOOK™
          </span>
        </div>

        <h1 className="mt-8 text-center font-serif text-[34px] leading-[1.08] sm:text-6xl font-black text-ink" data-id="element-168" data-mp="nb6lzq59zhn3">
          I Built This Because I Know How Easy It Is for a{' '}
          <em className="text-gold-dark" data-id="element-169" data-mp="381xn73sg3cct">Great Practice</em> to Become Disorganized.
        </h1>

        <p className="mx-auto mt-5 max-w-2xl text-center text-lg sm:text-xl leading-relaxed text-ink/75" data-id="element-170" data-mp="3j7zfnjujfuh7">
          A practical <strong className="text-ink" data-id="element-171" data-mp="3o6kg9kdpcg66">6-volume professional operating system</strong> designed to help you organize your
          rhinoplasty workflow, standardize recurring processes, and build a system you can actually use.
        </p>
        <p className="mt-3 text-center text-sm font-semibold text-ink/50" data-id="element-172" data-mp="3ebirwqr93i4n">Created by Ethan Whitmore</p>

        <img src={images.bundle} alt="Rhino Operating Playbook: 6 volumes, 5 bonuses and digital templates on tablet, phone and laptop" className="mx-auto mt-6 w-full max-w-3xl" data-id="element-173" data-mp="30fya5yn9d5yt" />

        <div className="mx-auto mt-4 max-w-xl rounded-2xl bg-ink p-5 text-white" data-id="element-174" data-mp="2viy2xkeo9x64">
          <p className="flex items-center gap-2 text-sm font-bold uppercase tracking-wider text-gold-light" data-id="element-175" data-mp="2vgtwovtawm2o">
            <TargetIcon className="h-4 w-4" aria-hidden="true" data-id="element-176" data-mp="2lkqzm4db3dml" />
            30-Day Implementation Goal
          </p>
          <p className="mt-2 text-[17px] leading-snug" data-id="element-177" data-mp="s1rt2qgj2avc">
            Build <strong className="text-gold-light" data-id="element-178" data-mp="s44gvk8yvfgb">10+ standardized checklists</strong>,{' '}
            <strong className="text-gold-light" data-id="element-179" data-mp="na08cwk1yzd4">5+ reusable templates</strong>, and{' '}
            <strong className="text-gold-light" data-id="element-180" data-mp="icromrj9an9r">1 complete end-to-end workflow map</strong> for your practice.
          </p>
        </div>

        <div className="mt-8" data-id="element-181" data-mp="1b0vx1kt7peg5">
          <CtaButton id="hero-cta" label="Get the Rhino Operating Playbook™" pulse data-id="element-182" data-mp="1b15o7bpztrnf" />
          <p className="mt-4 text-center text-sm text-ink/60" data-id="element-183" data-mp="1622kpvpnvthk">
            Instant access · One payment of just <strong className="text-ink" data-id="element-184" data-mp="1126pakv15adm">$27 USD</strong> · No subscription
          </p>
          <Countdown data-id="element-185" data-mp="x1efnqi8x3gt" />
        </div>
      </div>
    </header>;
}